import { useCallback } from 'react';
import { initializeSDK, loadSDK } from './sdkUtils';
import { updateUserProfile } from '../../utils/userProfile';
import { BRAND_DATA } from './brandData';
import { SDK_INIT_OPTIONS } from './constants';

export const useSDKInitialization = (setSdkReady, setSdkError, setInitializingSDK) => {
  // Handle SDK status changes
  const handleSdkStatusChange = useCallback((status) => {
    console.log('🔍 [SDKContext] SDK status changed:', status);
    if (status === 'initialized') {
      const storedOverridesJsonString = localStorage.getItem('launch_darkly_overrides');
      if (storedOverridesJsonString) {
        const overrides = JSON.parse(storedOverridesJsonString);
        window.nbc.identity.overrideLaunchDarklyConfigurations(overrides);
      }
    }
  }, []);

  // Handle authentication state changes
  const handleAuthenticationStateChange = useCallback((state) => {
    console.log('🔍 [SDKContext] Authentication state changed:', state);
    
    // Update user profile when authenticated
    if (state === 'authenticated' && window.nbc?.identity?.user) {
      updateUserProfile(window.nbc.identity.user);
    }
  }, []);



  // Initialize SDK with handlers
  const initializeSDKWithHandlers = useCallback(() => {
    return initializeSDK(
      setSdkReady,
      setSdkError,
      setInitializingSDK,
      handleSdkStatusChange,
      handleAuthenticationStateChange
    );
  }, [handleSdkStatusChange, handleAuthenticationStateChange, setSdkReady, setSdkError, setInitializingSDK]);

  // Load SDK with handlers
  const loadSDKWithHandlers = useCallback(() => {
    return loadSDK(setSdkError, initializeSDKWithHandlers);
  }, [initializeSDKWithHandlers, setSdkError]);

  return {
    handleSdkStatusChange,
    handleAuthenticationStateChange,
    loadSDKWithHandlers
  };
};

export const useOAuthLogin = () => {
  return useCallback(async () => {
    console.log('potato', {
      referringPage: SDK_INIT_OPTIONS.oauth.clientId,
      registrationReferrer: "None",
      redirectUrl: SDK_INIT_OPTIONS.oauth.redirectUrl,
      brandData: BRAND_DATA
    });
    if (!window.nbc?.identity?.launch) {
      throw new Error("SDK launch method not available");
    }

    await window.nbc.identity.launch({
      referringPage: SDK_INIT_OPTIONS.oauth.clientId,
      registrationReferrer: "None",
      redirectUrl: SDK_INIT_OPTIONS.oauth.redirectUrl,
      brandData: BRAND_DATA
    });
  }, []);
};
